import _ from 'lodash';

import {CREATE_ORDER, 
  CLOSE_ORDER, 
  LOAD_COMPROBATION, 
  ADD_ORDER_ITEM, 
  REMOVE_ORDER_ITEM, 
  LOAD_COMPROBATION_SUCCESS,
  CREATE_ORDER_SUCCESS,
  CLEAR_PURCHARSE_ORDER_STORE,
  LOAD_COMPROBATION_ERROR, } from '../actions/purcharseOrder';

import { getComprobation, 
  createComprobation, } from '../../services/route'; 

function initialState () {
  return { status: '', purcharseOrder: {}, message: '' };
}

const state = initialState();
const getters = {
  hasActivePurcharseOrder: state => {
    return !_.isEmpty(state.purcharseOrder);
  },
};
const actions = {
  [CREATE_ORDER]: async ({commit, dispatch}, routeId) => {
    commit(CREATE_ORDER);
    let comprobation = await createComprobation(routeId);

  },
  [LOAD_COMPROBATION]: async ({ commit, dispatch }, routeId) => {
    commit(LOAD_COMPROBATION);
    try{
      let response = await getComprobation(routeId);
      let purcharseOrderData = {};
      if (!_.isEmpty(response.data)) {
        purcharseOrderData = response.data;
      }
      commit(LOAD_COMPROBATION_SUCCESS, purcharseOrderData);
    }catch (err) {
      commit(LOAD_COMPROBATION_ERROR, err.message);
    }
  },
  [CLEAR_PURCHARSE_ORDER_STORE]: ({commit}) => {
    commit(CLEAR_PURCHARSE_ORDER_STORE);
  },
};

const mutations = {
  [CREATE_ORDER]: (state) => {
    state.purcharseOrder = {};
    state.status = 'created';
  },
  [CREATE_ORDER_SUCCESS]: (state, purcharseOrder) => {
    state.status = 'success';
    state.purcharseOrder = purcharseOrder;
  },
  [LOAD_COMPROBATION]: (state) => {
    state.purcharseOrder = {};
    state.status = 'loading';
  },
  [LOAD_COMPROBATION_SUCCESS]: (state, comprobation) => {
    state.status = 'success';
    state.purcharseOrder = comprobation;
  },
  [LOAD_COMPROBATION_ERROR]: (state, message) => {
    state.status = 'error';
    state.message = message;
  },

  /**
   * This assign is for the object don't loose reactivity;
   * https://github.com/vuejs/vuex/issues/1118
   */
  [CLEAR_PURCHARSE_ORDER_STORE]: (state) => {
    const s = initialState();
    Object.keys(s).forEach(key => {
      state[key] = s[key]
    })
  },
};

export default {
  state,
  getters,
  actions,
  mutations
} 